import {
	connect
} from 'react-redux'
import MaintenanceSearchRecordComponent from '../components/MaintenanceSearchRecordComponent.jsx';
import {
} from '../actions';

const mapStateToProps = (state) => ({
	roles: state.getIn(['authReducer', 'roles']),
	card: state.getIn(['maintenanceSearchReducer', 'search_card']),
	prePhotos: state.getIn(['maintenanceSearchReducer', 'search_prePhotos']),
	postPhotos: state.getIn(['maintenanceSearchReducer', 'search_postPhotos'])
})

const mapDispatchToProps = (dispatch) => ({
})

const MaintenanceSearchRecordContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceSearchRecordComponent)

export default MaintenanceSearchRecordContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceSearchRecordContainer.jsx